import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map, Observable } from 'rxjs';

import { RegimenLaboral } from '@shared/models';
import { ResponseWrapper } from '@shared';
import { environment } from '@env';

const API_URL = environment.URL_SERVICIOSBACK;
const ENDPOINT_REGIMEN_LABORAL = '/regimen-laboral';

@Injectable({
  providedIn: 'root',
})
export class RegimenLaboralService {
  private readonly API_URL_REGIMEN_LABORAL = API_URL + ENDPOINT_REGIMEN_LABORAL;
  private http = inject(HttpClient);

  listarRegimenLaboral(): Observable<RegimenLaboral[]> {
    return this.http.get<ResponseWrapper<RegimenLaboral[]>>(this.API_URL_REGIMEN_LABORAL).pipe(
      map((res) => {
        return res.data;
      }),
    );
  }
}
